import { useGetNotificationsInfiniteQuery } from "entities/notification";
import type { NotificationType } from "entities/notification";
import { toInfiniteListState } from "shared/ui";

export const useInboxSection = (type: NotificationType) => {
  // Список свежий при каждом открытии dropdown, badge обновляется поллингом.
  const result = useGetNotificationsInfiniteQuery(
    { type },
    { refetchOnMountOrArgChange: true },
  );

  return toInfiniteListState(result, (page) => page.categories[type].items);
};
